import React, { useState, useEffect } from 'react';
import TabComponent from '../../components/TabComponent';
import GoldRate from './GoldRate';
import OurReport from './OurReport';
import LedgerIndex from './Ledger';
import PortfolioReport from './PortfolioReport';

export default function OverviewIndex(): JSX.Element {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const role: string | null = localStorage.getItem('role');
  const tabOptions = [
    {
      to: '',
      label: 'Our Report',
      index: 0,
    },
    {
      to: '',
      label: 'Portfolio Report (Beta)',
      index: 1,
    },
  ];

  if (role === 'superadmin' || role === 'auditor') {
    tabOptions.push({
      to: '',
      label: 'Ledger',
      index: 2,
    });
    tabOptions.push({
      to: '',
      label: 'Gold Rate',
      index: 3,
    });
  }

  if (role === 'manager') {
    tabOptions.push({
      to: '',
      label: 'Ledger',
      index: 2,
    });
  }

  useEffect(() => {
    if (role === 'superadmin' || role === 'auditor') {
      setSelectedIndex(3);
    }
  }, []);

  return (
    <div className="transactions__page">
      <h1>Overview</h1>
      <div className="">
        <TabComponent
          taboptions={tabOptions}
          selectedTab={selectedIndex}
          setSelectedTab={setSelectedIndex}
        />
      </div>
      <div className="main__container">
        {selectedIndex === 3 && <GoldRate />}
        {selectedIndex === 0 && <OurReport />}
        {selectedIndex === 1 && <PortfolioReport />}
        {selectedIndex === 2 && <LedgerIndex />}
      </div>
    </div>
  );
}
